<!--<c-footer>-->
  <div class="ms-auto">
    Powered by
    <a href="https://www.ima-ems.com" target="_blank">IMA</a>
    <span>Team &pi;&nbsp;&nbsp;&nbsp;&nbsp;</span>
  </div>
<!--</c-footer>-->
